// extracted by mini-css-extract-plugin
export var container = "_25-0";
export var error = "_25-9";
export var label = "_25-5";
export var light = "_25-6";
export var md = "_25-3";
export var sm = "_25-2";
export var thin = "_25-8";
export var thinBold = "_25-7";
export var vertical = "_25-4";
export var xs = "_25-1";